const trimRightSlash = url => String(url || '').replace(/\/+$/, '')

const apiBaseUrl = trimRightSlash(process.env.BACKEND_API_BASE_URL || 'http://127.0.0.1:5000')
const socketUrl = trimRightSlash(process.env.BACKEND_SOCKET_URL || `${apiBaseUrl}/ws`)

export default {
    apiBaseUrl,
    socketUrl,
    tiandituKey: process.env.TIANDITU_KEY || 'd4ebcad16567cac8d2501c693292124f'
}




// WEBPACK FOOTER //
// ./src/config/index.js